// @ts-expect-error
import { jitsiLocalStorage } from '@jitsi/js-utils';
import { createSlice } from "@reduxjs/toolkit";
import ReducerRegistry from "../base/redux/ReducerRegistry";
const initialState = {
    functions: [],
    lang: localStorage.getItem('language') || jitsiLocalStorage.getItem('language') || 'vi'
};
const userManage = createSlice({
    name: 'features/user-manage',
    initialState,
    reducers: {
        updateUserFunctions: (state, action) => {
            state.functions = action.payload;
        },
        updateLangUser: (state, action) => {
            state.lang = action.payload;
        }
        // updateUserByToken: (state, action) => {
        //     state.userByToken = action.payload;
        // },
        // updateUserConfig: (state, action) => {
        //     state.config = action.payload;
        // },
        // updateShowFeedback: (state, action) => {
        //     state.isShowFeedback = action.payload;
        // }
    }
});
ReducerRegistry.register('features/user-manage', userManage.reducer);
export const { updateUserFunctions, updateLangUser,
// updateUserByToken,
// updateUserConfig,
// updateShowFeedback
 } = userManage.actions;
export default userManage.reducer;
